import { render, staticRenderFns } from "./ItemsNumberCol.vue?vue&type=template&id=5755b7fd"
import script from "./ItemsNumberCol.vue?vue&type=script&lang=ts"
export * from "./ItemsNumberCol.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports